import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import TreeselectInfoOption from '@/views/Automation/CampaignCreatorV2/components/Treeselect/TreeselectInfoOption.ts.vue';
import { countries } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/countries';
import { country_group } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/country_group';
import useABVariableStore from '@/views/Automation/CampaignCreatorV2/store/AbVariables';
import useAdSetStore from '@/views/Automation/CampaignCreatorV2/store/AdSet';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import { SupportedEntities } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { CardLayer, GeoTargeting, TreeselectOptionInfo } from '@/views/Automation/CampaignCreatorV2/types';
import treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialAdCategories.ts',
  setup(__props) {

const specialAdCategoriesOptions: TreeselectOptionInfo[] = [
  {
    id: 'CREDIT',
    label: 'Credit',
    info: 'Ads for credit card offers, auto loans, long-term financing or other related opportunities.',
    icon: 'creditCard',
  },
  {
    id: 'EMPLOYMENT',
    label: 'Employment',
    info: 'Ads for job offers, internships, professional certification programs or other related opportunities.',
    icon: 'bag',
  },
  {
    id: 'HOUSING',
    label: 'Housing',
    info: 'Ads for real estate listings, homeowners insurance, mortgage loans or other related opportunities.',
    icon: 'home',
  },
  // {
  //   id: 'SOCIAL_ISSUES',
  //   label: 'Social issues, elections or politics',
  //   info: 'Ads about social issues (such as the economy, or civil and social rights), elections or political figures or campaigns.',
  //   icon: 'campaignSpeaker',
  // },
];

const campaignStore = useCampaignStore();
const campaignGetters = storeToRefs(campaignStore);

const specialAdCategoriesValue = computed(() => {
  const categories = campaignGetters.getField.value('special_ad_categories').value?.[0];
  return categories?.value || [];
});
const specialAdCategoriesCountriesValue = computed(() => {
  const categories = campaignGetters.getField.value('special_ad_category_country').value?.[0];
  return categories?.value || [];
});
const locationOptions = ref<any>([]);

function updateSpecialAdCategories(categories: string[]) {
  if (!categories.length) {
    useABVariableStore().resetField(SupportedEntities.campaign, 'special_ad_category_country');
  }
  campaignStore.addOrEditVariable('special_ad_categories', {
    field: 'special_ad_categories',
    value: categories,
    variableId: 'special_ad_categories',
  });
}

function updateSpecialAdCategoriesCountriesValue(categories: TreeselectOptionInfo[]) {
  const countries = categories
    ?.map((e) => e.children || [e])
    .flat()
    .filter(Boolean);

  if (countries.length) {
    useAdSetStore().switchToSpecialAdCategories(countries as any);
  }

  campaignStore.addOrEditVariable('special_ad_category_country', {
    field: 'special_ad_category_country',
    value: countries as unknown as Array<GeoTargeting>,
    variableId: 'special_ad_category_country',
  });
}

onBeforeMount(() => {
  const mapped = country_group
    .filter((e) => !!e.special_category_support)
    .map((cg) => {
      const group = {
        ...cg,
        id: cg.key,
        label: cg.name,
        type: cg.type,
        children: cg.country_codes.map((c) => {
          const country = countries.find((cc) => cc.country_code === c);
          const isWorldwide = cg.is_worldwide;
          return {
            ...country,
            id: `${[isWorldwide ? undefined : cg.key, country?.key].filter(Boolean).join('-')}`,
            label: country?.name,
          };
        }),
      };
      return group;
    });
  locationOptions.value = mapped;
});

return { __sfc: true,specialAdCategoriesOptions, campaignStore, campaignGetters, specialAdCategoriesValue, specialAdCategoriesCountriesValue, locationOptions, updateSpecialAdCategories, updateSpecialAdCategoriesCountriesValue, CcCard, CcCardItem, TreeselectInfoOption, CardLayer, treeselect }
}

})